// Code generated by protoc-gen-weave-ts. DO NOT EDIT.
import * as fm from "../../../fetch.pb.js";
// FaxService Contains all the endpoints related to the fax system
export const FaxService = {
    // ListFaxes Return all (paginated) faxes optionally filtered by direction with allowed values outbound and inbound.
    // Key set pagination will use last_created_at and last_id as query parameters
    ListFaxes(fn, req) {
        return fn(`/fax/v1/faxes?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    // GetFax Return a single fax by id.
    GetFax(fn, req) {
        try {
            fm.validateUrlParam(req["faxId"], "faxId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/fax/v1/faxes/${req["faxId"]}?${fm.renderURLSearchParams(req, ["faxId"])}`, { method: "GET" });
    },
    // GetFaxDeliveryReport Returns the delivery report media id field for a fax record.
    // For inbound faxes this API will return a 400 Bad Request.
    // For older faxes where the delivery report media id is not present, this API will make a call to the fax-media service to generate the delivery report.
    // The reason to place this API in the fax service is to avoid extra calls between comm-fax and fax-media service. Because we are storing the delivery confirmation media id
    // as a database column in the faxes table, placing it in fax-media would mean extra rpc calls to fetch and update the fax record.
    // All the media related operations are already present in the fax-media service. This API is merely calling the media service to generate the delivery report.
    GetFaxDeliveryReport(fn, req) {
        try {
            fm.validateUrlParam(req["faxId"], "faxId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/fax/v1/faxes/${req["faxId"]}/delivery-report?${fm.renderURLSearchParams(req, ["faxId"])}`, { method: "GET" });
    },
    ListBlockedFaxes(fn, req) {
        return fn(`/fax/v1/faxes/blocked?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    ListArchivedFaxes(fn, req) {
        return fn(`/fax/v1/faxes/archived?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    UpdateFaxArchiveStatus(fn, req) {
        return fn(`/fax/v1/faxes/archive/status`, { method: "PATCH", body: JSON.stringify(req, fm.replacer) });
    },
    // Send Send fax to multiple recipients
    Send(fn, req) {
        return fn(`/fax/v1/faxes`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    // Retry Retry sending a single fax.
    Retry(fn, req) {
        return fn(`/fax/v1/faxes/retry`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    // CountUnread Count unread faxes.
    CountFaxes(fn, req) {
        return fn(`/fax/v1/faxes/count?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    SearchFaxes(fn, req) {
        return fn(`/fax/v1/faxes/search?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    // UpdateFaxes The only field that can be updated is views.
    // The field name here is hasRead (it is an instruction to update the views field)
    // Because we are allowing only a single field to be updated we are not returning anything.
    UpdateFaxes(fn, req) {
        return fn(`/fax/v1/faxes`, { method: "PATCH", body: JSON.stringify(req, fm.replacer) });
    },
    // ForwardFax Forward faxes to multiple recipients.
    // This accepts a fax_id and a list of contact_ids.
    ForwardFax(fn, req) {
        return fn(`/fax/v1/faxes/forward`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    // ListNumbers List all the fax numbers for a location and optionally pass a default=true query parameter to get the default number
    ListNumbers(fn, req) {
        return fn(`/fax/v1/faxes/numbers?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    // DeleteFaxes Delete multiple faxes. This is a soft delete.
    // In the delete HTTP request fax_ids can be passed multiple times to delete multiple faxes.
    DeleteFaxes(fn, req) {
        return fn(`/fax/v1/faxes?${fm.renderURLSearchParams(req, [""])}`, { method: "DELETE" });
    },
    // UpsertContact Creates or updates a single fax contact
    UpsertContact(fn, req) {
        return fn(`/fax/v1/contacts`, { method: "PUT", body: JSON.stringify(req, fm.replacer) });
    },
    // DeleteContacts Soft deletes multiple contacts corresponding to the passed contact ids.
    // In the delete HTTP request contact_ids can be passed multiple times to delete multiple contacts.
    DeleteContacts(fn, req) {
        return fn(`/fax/v1/contacts?${fm.renderURLSearchParams(req, [""])}`, { method: "DELETE" });
    },
    // ListContacts lists all the fax contacts. Also optionally search through the contact directory.
    // Results will paginated via key set pagination sorted on first name.
    ListContacts(fn, req) {
        return fn(`/fax/v1/contacts?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    GetContact(fn, req) {
        try {
            fm.validateUrlParam(req["contactId"], "contactId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/fax/v1/contacts/${req["contactId"]}?${fm.renderURLSearchParams(req, ["contactId"])}`, { method: "GET" });
    },
    // SearchContacts Search through the contact directory (non archived only). Results are paginated using limit and offset and ranked
    // according to the search score. The search score is calculated using postgres's ts_rank function.
    // See: https://www.postgresql.org/docs/current/textsearch-controls.html#TEXTSEARCH-RANKING
    SearchContacts(fn, req) {
        return fn(`/fax/v1/contacts/search?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    // ListDrafts Lists all the fax drafts based on the corresponding location id and user id.
    // Results will paginated via key set pagination sorted on created_at.
    // DEPRECATED: Use fax-draft service corresponding call.
    ListDrafts(fn, req) {
        return fn(`/fax/v1/drafts?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    // GetDraft Get a single draft by id.
    // DEPRECATED: Use fax-draft service corresponding call.
    GetDraft(fn, req) {
        try {
            fm.validateUrlParam(req["draftId"], "draftId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/fax/v1/drafts/${req["draftId"]}?${fm.renderURLSearchParams(req, ["draftId"])}`, { method: "GET" });
    },
    // UpsertDraft This is a PUT style update with the capability to create a new draft if the passed id is empty
    // DEPRECATED: Use fax-draft service corresponding call.
    UpsertDraft(fn, req) {
        return fn(`/fax/v1/drafts`, { method: "PUT", body: JSON.stringify(req, fm.replacer) });
    },
    // DeleteDrafts Deletes multiple drafts corresponding to passed draft ids.
    // In the delete HTTP request draft_ids can be passed multiple times to delete multiple drafts.
    // DEPRECATED: Use fax-draft service corresponding call.
    DeleteDrafts(fn, req) {
        return fn(`/fax/v1/drafts?${fm.renderURLSearchParams(req, [""])}`, { method: "DELETE" });
    },
    // PreviewDraft Preview a draft fax.
    // This will return an id of a merged PDF uploaded to media manager.
    // DEPRECATED: Use fax-draft service corresponding call.
    PreviewDraft(fn, req) {
        return fn(`/fax/v1/drafts/preview`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    // RenderCoversheetTemplate Preview a draft coversheet being built by the user in the WYSIWYG editor.
    // This is different from previewing the entire draft.
    // DEPRECATED: Use fax-draft service corresponding call.
    PreviewDraftCoversheet(fn, req) {
        return fn(`/fax/v1/drafts/coversheet/preview`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    // TagFaxes Tagging faxes.
    TagFaxes(fn, req) {
        return fn(`/fax/v1/faxes/tag`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    // UntagFaxes Untagging faxes.
    UntagFaxes(fn, req) {
        return fn(`/fax/v1/faxes/untag`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    // BlockContact Block a contact for a location.
    BlockContact(fn, req) {
        return fn(`/fax/v1/contacts/block`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    // UnblockContact Unblock a contact for a location.
    UnblockContact(fn, req) {
        return fn(`/fax/v1/contacts/unblock`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    // IsContactBlocked Check if a contact is blocked for a location using the fax number.
    IsContactBlocked(fn, req) {
        return fn(`/fax/v1/contacts/is-blocked?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
};
